/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const createNavigationStyles = makeStyles<Theme, { drawerWidth: number }>(theme => ({
  header: {
    padding: '10px',
    backgroundColor: '#FFFF',
    display: 'flex',
    justifyContent: 'center',
  },
  content: {
    padding: '0 16px',
    flex: 1,
  },
  colorIcons: {
    color: '#b4b8ce',
    '&:hover': {
      color: '#5d78ff',
      backgroundColor: '#f0f3ff',
    },
  },
  listItem: {
    color: theme.palette.text.primary,
    paddingLeft: '30px',
    '& .MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
      color: theme.palette.text.primary,
    },
    '& .MuiListItemIcon-root': {
      minWidth: 'auto',
      marginRight: '16px',
      width: '20px',
      height: '20px',
    },
  },
  listItemText: {
    width: '180px',
    paddingRight: 2,
    whiteSpace: 'nowrap',
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
  },
  navLink: {
    textDecoration: 'none',
  },
  imageLogo: {
    width: 'auto',
    height: '80px',
    maxWidth: '143px',
    maxHeight: '100%',
  },
  spinner: {
    margin: '0 auto',
    marginTop: 25,
  },
  fullWidth: {
    width: '100%',
  },
  bottomLinks: {
    marginTop: '10px',
    width: '100%',
    alignSelf: 'flex-end',
  },
  projectsTree: {},
  organizations: {
    marginTop: '40px',
  },
  groupName: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '12px',
    lineHeight: '15px',
    alignItems: 'center',
    padding: '0 12px',
    '& .MuiIconButton-root': {
      padding: 0,
    },
  },
  noticeText: {
    color: theme.palette.text.primary,
    fontSize: '12px',
    lineHeight: '15px',
    padding: '12px',
  },
  createProjectSvg: {
    width: '20px',
    height: '20px',
  },
  alignCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
}));

export { createNavigationStyles };
